import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../components/Navigation';
import logo from '../../assets/colliers89.png'
import './Header.css';

const Header = () => (
  <header>
    <span className="logo">
      <Link 
        to="/"
      >
        <img src={logo} alt='London Central Developments' />
      </Link>
    </span>
    <Navigation className="navigation" />
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx